import { Box, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { PortalSourcingEventDetailDto, Regulation } from "../../../../autogen/bff-api";
import { useDisplayDate } from "../../../../common/formatting/useDisplayDate";
import { statutoryClauses } from "../../../v2/sourcing-event/award/awardLetterTemplates";
import { isPrivatePortalEvent } from "./PrivateInviteCta";

interface Props {
  event: PortalSourcingEventDetailDto;
  regulation: Regulation | null;
  standstillExpiresAt?: string | null;
}

export const AwardStatutoryNotices = ({ event, regulation, standstillExpiresAt }: Props) => {
  const { t } = useTranslation();
  const displayDate = useDisplayDate();
  const clauses = statutoryClauses({
    eventRunsPrivateFlow: isPrivatePortalEvent(event),
    buyerRunsPublicProcurements: event.buyerRunsPublicProcurements ?? false,
    regulation,
  });
  const hasExpired = !!standstillExpiresAt && new Date(standstillExpiresAt) < new Date();

  return (
    <>
      {clauses.standstill && standstillExpiresAt && (
        <Box bg="smBackground" rounded="md" border="1px solid" borderColor="smBorder" p="3">
          <Text fontSize="sm" color="smText">
            {hasExpired
              ? t("The standstill period has expired")
              : t("The standstill period expires {{date}}. The contract cannot be signed before it is over.", {
                  date: displayDate(standstillExpiresAt),
                })}
          </Text>
        </Box>
      )}
      <Text fontSize="sm" color="smMuted">
        {clauses.complaint ?? t("If you have questions about the decision, contact {{buyer}}.", { buyer: event.buyerName })}
      </Text>
    </>
  );
};
